import { render, staticRenderFns } from "./IconSale.vue?vue&type=template&id=cf507c64&"
import script from "./IconSale.vue?vue&type=script&lang=js&"
export * from "./IconSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports